import { appData } from '@/mocks/home';

export default function App() {
  return (
    <section id="app" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16 bg-background-100 rounded-2xl p-8 md:p-12 border border-background-200/70">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">{appData.title}</h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">{appData.description}</p>

            <div className="flex flex-wrap justify-center lg:justify-start gap-3 mb-8">
              {appData.features.map((feat, idx) => (
                <span
                  key={idx}
                  className="px-3 py-1.5 rounded-full bg-background-50 text-xs font-medium text-foreground-700 border border-background-200/70"
                >
                  {feat}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 rounded-lg hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap"
              >
                <i className="ri-apple-fill text-lg"></i>
                <span className="text-sm font-medium">{appData.iosBadge}</span>
              </a>
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 rounded-lg hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap"
              >
                <i className="ri-android-fill text-lg"></i>
                <span className="text-sm font-medium">{appData.androidBadge}</span>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-sm">
            <div className="relative mx-auto w-64">
              <div className="absolute inset-0 bg-primary-500/20 rounded-[2.5rem] blur-2xl"></div>
              <div className="relative bg-background-50 rounded-[2.5rem] p-3 border-4 border-foreground-100 shadow-lg">
                <div className="rounded-[2rem] bg-primary-500 p-6 flex flex-col items-center gap-3">
                  <div className="w-12 h-12 rounded-2xl bg-background-50/20 flex items-center justify-center">
                    <i className="ri-flashlight-line text-2xl text-background-50"></i>
                  </div>
                  <span className="font-brand text-2xl text-background-50">每日吃瓜</span>
                  <span className="text-xs text-background-50/80">随身吃瓜神器</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}